export default function () {
  return {
    // Layout helpers
  }
}